/* eslint-disable guard-for-in */
import {Pipe, PipeTransform} from '@angular/core';
import { UtilityService } from '../services/utility_functions/utility_functions.service';
import * as dayjs from 'dayjs';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import moment from 'moment';

dayjs.extend(utc);
dayjs.extend(timezone);

@Pipe({
    name: 'datetime',
    pure: true
})
export class DateTimePipe implements PipeTransform {
    dateTimeFormat: any = 'MM/DD/YYYY';
    timezone: any = dayjs?.tz?.guess();
    constructor(private utilityService: UtilityService){
        this.dateTimeFormat = this.utilityService.dateTimeFormat;
        this.timezone = this.utilityService.timeZone;
    }
    transform(value: any, format=this.dateTimeFormat, timeZone: string = this.timezone, showTimeZone: boolean = false): any {
        if(showTimeZone){
            const abbreviation: string = this.getAbbreviation(value, timeZone);
            format = `${format} [(${abbreviation})]`;
        }
        if (value) {
            value = moment(value).isUTC() ?  moment(value).tz(timeZone).format(format) : moment(value).utc().tz(timeZone).format(format);
        }
        return value;
    }

    transformFormatedUTC(value: any, format = this.dateTimeFormat): string{
        if (value) {
            value = dayjs.utc(value,format).tz(this.timezone).format(this.dateTimeFormat);
        }
        return value;
    }

    getAbbreviation(value: any, timeZone: string): string {
        const momentValue = moment.tz(value, timeZone); // Get the current time in the specified timezone
        let abbreviation: string = momentValue?.format('z'); // Try to get the abbreviation directly
    
        // If the abbreviation looks like a numeric offset (like +04), format it as "GMT+04:00"
        if (momentValue && /^[+-]\d{2}(:?\d{2})?$/.test(abbreviation)) {
            const offset: string = momentValue.format('Z'); // Get the offset in the format +04:00
            abbreviation = `GMT${offset}`;
        }
    
        return abbreviation; 
    }
    
}
